import React, { useEffect, useState } from "react";
import images from "../../../Utils/importImages";
import "./MyFlightBookings.css";
import { useDispatch, useSelector } from "react-redux";
import AirlineLogos from "./Components/AirlineLogos";
import Timer from "./Components/Timer";
import { useNavigate } from "react-router-dom";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import ReactDOMServer from "react-dom/server";
import TicketFormat from "./TicketFormat";
import ReactDOM from "react-dom/client";
import Popup from "./Components/BookingPopup";
import EmailTicket from "./EmailTicket";
import Invoice from "./Invoice";
import WebCheckin from "./WebCheckin";
import Swal from "sweetalert2";

import FailedBookingPopup from "./Components/FailedBookingPopup";
import { Call_Hold_and_Sell } from "../../../Utils/MyBookings_Func";
import { getLocalStorageJSON } from "../../../Utils/localStorageFunc";
import { MAIN_URL } from "../../../Configs/Urls";
import axios from "axios";

function MyFlightBookings() {
  let dispatch = useDispatch();

  const { isUserLogin, isAdminLogin, userLoggedInData } = useSelector(
    (state) => state.user
  );

  console.log("userLoggedInData is : ", userLoggedInData);    // userid is avavailable at userLoggedInData.id

  let [FlightBookings, SetFlightBookings] = useState([]);


  useEffect(() => {
    const fetchFlightBookings = async () => {
      try {
        if (userLoggedInData?.id) {
          const response = await axios.get(
            `${MAIN_URL}bookings/flights/user/${userLoggedInData.id}`
          );
          console.log("Flight bookings:", response.data);
          SetFlightBookings(response.data); // update state with the response data
        }
      } catch (error) {
        console.error("Error fetching flight bookings:", error);
      }
    };

    fetchFlightBookings();
  }, [userLoggedInData?.id]); // run only when user ID is available


  const formatPriceWithCommas = (value) => {
    if (!value) return "0";
    const intValue = value.split(".")[0]; // Get integer part before the decimal
    return parseInt(intValue).toLocaleString("en-IN"); // Use Indian number format
  };

  let [activeBookingHeader, setActiveBookingHeader] = useState("upcoming");

  let navigate = useNavigate();

  let proceedHoldBooking = () => {
    alert("proceed hold booking");
  };

  // Inside your component:
  let [OpenFailedBookingPopup, setOpenFailedBookingPopup] = useState(false);

  let [FailedBookingPopupData, setFailedBookingPopupData] = useState({
    hasError: false,
    return: false,
    Heading: "Loading",
    Message: "Please Wait We are Fetching your Booking's Data",
    showContinue: false,
    continueButtonText: "",
  });

  let closeTheFailedBookingPopup = () => {
    setOpenFailedBookingPopup(false);

    setFailedBookingPopupData({
      hasError: false,
      return: false,
      Heading: "Loading",
      Message: "Please Wait We are Fetching your Booking's Data",
      showContinue: false,
      continueButtonText: "",
    });
  };

  let proceedFailedBooking = async (url, booking_id) => {
    console.log("url is : ", url); // debug from here

    Swal.fire({
      title: "You will be Re-Directed to Complete Your Booking",
      showCancelButton: true,
      confirmButtonText: "Confirm",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setOpenFailedBookingPopup(true);
        setFailedBookingPopupData({
          hasError: false,
          return: false,
          Heading: "Loading",
          Message: "Please wait, we are fetching your booking data...",
          showContinue: false,
          continueButtonText: "",
        });

        const result = await Call_Hold_and_Sell(isUserLogin, url, booking_id);

        if (result.hasError === false) {
          setFailedBookingPopupData({
            hasError: false,
            return: false,
            Heading: "Booking Found Successfully",
            Message: "Please Wait , Returning you to Payment Gateway ...",
            showContinue: false,
            continueButtonText: "",
            onClickContinue: null,
          });

          // setOpenFailedBookingPopup(false); // close on success
        } else {
          setFailedBookingPopupData({
            hasError: true,
            return: result.return,
            Heading: result.Heading,
            Message: result.Message,
            showContinue: result.showContinue,
            continueButtonText: result.continueButtonText,
            onClickContinue: result.onClickContinue || null,
          });
        }
      }
    });
  };

  const downloadTicket = async (data) => {
    // Create a hidden container
    const container = document.createElement("div");
    container.style.position = "fixed";
    container.style.top = "-10000px";
    container.style.left = "-10000px";
    container.style.width = "800px"; // Set appropriate width
    container.style.background = "#fff";
    document.body.appendChild(container);

    // Render component to container
    const element = <TicketFormat Data={data} nav={null} />;
    const htmlString = ReactDOMServer.renderToString(element);
    container.innerHTML = htmlString;

    // Wait for images/fonts to load (optional delay)
    await new Promise((res) => setTimeout(res, 1000));

    // Convert to canvas
    const canvas = await html2canvas(container, {
      scale: 2,
      useCORS: true,
    });

    const imgData = canvas.toDataURL("image/png");
    const pdf = new jsPDF("p", "mm", "a4");

    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

    pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
    pdf.save("ticket.pdf");

    // Clean up
    document.body.removeChild(container);
  };

  let [openEmailTicketPopup, setOpenEmailTicketPopup] = useState(false);

  let [emailData, setEmailData] = useState(null);
  let closeTheEmailTicketPopup = () => {
    setEmailData(null);
    setOpenEmailTicketPopup(false);
  };

  let openTheEmailTicket = (data) => {
    setEmailData(data);
    setOpenEmailTicketPopup(true);
  };

  let [openInvoicePopup, setOpenInvoicePopup] = useState(false);

  let [invoiceData, setInvoiceData] = useState(null);

  let closeTheInvoicePopup = () => {
    setInvoiceData(null);
    setOpenInvoicePopup(false);
  };

  let openTheInvoice = (data) => {
    setInvoiceData(data);
    setOpenInvoicePopup(true);
  };

  let [openCheckinPopup, setOpenCheckinPopup] = useState(false);

  let [CheckinData, setCheckinData] = useState(null);
  let [CheckinLinks, setCheckinLinks] = useState(null);

  let closeTheCheckinPopup = () => {
    setCheckinData(null);
    setCheckinLinks(null);
    setOpenCheckinPopup(false);
  };

  let openTheWebCheckin = (links, data) => {
    setCheckinData(data);
    setCheckinLinks(links);
    setOpenCheckinPopup(true);
  };

  const printTicket = (data) => {
    const printWindow = window.open("", "_blank", "width=800,height=600");

    // Collect all stylesheets from the current document
    const styles = Array.from(document.styleSheets)
      .map((sheet) => {
        try {
          if (sheet.href) {
            return `<link rel="stylesheet" href="${sheet.href}" />`;
          } else if (sheet.ownerNode && sheet.ownerNode.innerHTML) {
            return `<style>${sheet.ownerNode.innerHTML}</style>`;
          }
        } catch (e) {
          console.warn("Style sheet couldn't be loaded:", e);
          return "";
        }
      })
      .join("\n");

    const htmlContent = `
      <html>
        <head>
          <title>Print Ticket</title>
          ${styles}
        </head>
        <body>
          <div id="print-ticket-root"></div>
          <script>
            window.onload = function () {
              setTimeout(() => {
                window.print();
                window.close();
              }, 1000);
            };
          </script>
        </body>
      </html>
    `;

    printWindow.document.write(htmlContent);
    printWindow.document.close();

    // Wait for window to finish loading before injecting React
    const interval = setInterval(() => {
      const rootEl = printWindow.document.getElementById("print-ticket-root");
      if (rootEl) {
        const root = ReactDOM.createRoot(rootEl);
        root.render(<TicketFormat Data={data} nav={null} />);
        clearInterval(interval);
      }
    }, 100);
  };

  return (
    <>
      <div className="myflight-bookings proxima_regular">
        {/* <h2>{reviewPageData.OpenPopupData?.Heading}</h2>
                {!Array.isArray(reviewPageData.OpenPopupData?.Data) ? (
                  <p>{reviewPageData.OpenPopupData?.Data}</p>
                ) : (
                  <div>
                    {reviewPageData.OpenPopupData?.Data.map((item, id) => {
                      return <div>{item.Message}</div>;
                    })}
                  </div>
                )} */}

        <div className="internal-tab-head">
          <div className="add-traveller-head">
            <h3 className="proxima_semibold">Flight Bookings</h3>
            <div className="flight-bookings-stepper">
              <ul className="flight-bookings-steppers-list">
                <li
                  className={`upcoming-userdb ${activeBookingHeader == "upcoming"
                      ? "active-flight-booking-stepper"
                      : ""
                    }`}
                  onClick={() => setActiveBookingHeader("upcoming")}
                >
                  <h4 className="proxima_semibold">Upcoming</h4>
                  <span>{FlightBookings?.upcoming?.length} Booking</span>
                </li>
                <li
                  className={`unsuccessful-userdb ${activeBookingHeader == "hold"
                      ? "active-flight-booking-stepper"
                      : ""
                    }`}
                  onClick={() => setActiveBookingHeader("hold")}
                >
                  <h4 className="proxima_semibold">Hold</h4>
                  <span>{FlightBookings?.hold?.length} Booking</span>
                </li>
                <li
                  className={`cancelled-userdb ${activeBookingHeader == "cancelled"
                      ? "active-flight-booking-stepper"
                      : ""
                    }`}
                  onClick={() => setActiveBookingHeader("cancelled")}
                >
                  <h4 className="proxima_semibold">Cancelled</h4>
                  <span>{FlightBookings?.cancelled?.length} Booking</span>
                </li>
                <li
                  className={`completed-userdb ${activeBookingHeader == "completed"
                      ? "active-flight-booking-stepper"
                      : ""
                    }`}
                  onClick={() => setActiveBookingHeader("completed")}
                >
                  <h4 className="proxima_semibold">Completed</h4>
                  <span>{FlightBookings?.completed?.length} Booking</span>
                </li>
                <li
                  className={`unsuccessful-userdb ${activeBookingHeader == "unsuccessful"
                      ? "active-flight-booking-stepper"
                      : ""
                    }`}
                  onClick={() => setActiveBookingHeader("unsuccessful")}
                >
                  <h4 className="proxima_semibold">Unsuccessful</h4>
                  <span>{FlightBookings?.unsuccessful?.length} Booking</span>
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* // chekc booking id validation of acc to ticket / */}

        <ul className="my-bookings-list-userdb">
          {FlightBookings?.[activeBookingHeader]?.map((item, id) => {
            return (
              <li key={id}>
                <div className="userdb-mybookings-route">
                  <div className="left-userdb-mybookings-route">
                    <div className="plane-ico">
                      <img src={images["airline-ico.svg"]} alt="" />
                    </div>
                    <div className="booking-route-info">
                      <div className="top-booking-route-info">
                        <ul className="userdb-route-my-booking proxima_semibold">
                          <li>{item.from}</li>
                          <img src={images[item.arrow_icon]} />
                          <li>{item.to}</li>
                          <li
                            style={{ marginLeft: "10px" }}
                            className="proxima_regular color_light-gray-black"
                          >
                            {item.ViaCities.length > 0 && (
                              <>Via {item.ViaCities.join(", ")}</>
                            )}
                          </li>
                        </ul>
                      </div>
                      <div className="bottom-booking-route-info">
                        Booking ID: {item.booking_id}
                      </div>
                    </div>
                  </div>
                  <div className="right-userdb-mybookings-route">
                    <ul className="userdb-right-booking-info">
                      <li>
                        <h4 className="proxima_semibold">Trip Type</h4>
                        <span className="proxima_semibold">
                          {item.trip_type}
                        </span>
                      </li>
                      <li>
                        <h4 className="proxima_semibold">Booking Date</h4>
                        <span className="proxima_semibold">
                          {item.booking_date}
                        </span>
                      </li>
                      <li>
                        <h4 className="proxima_semibold">Current Status</h4>
                        <span
                          className={`capital-status ${item.current_status.color}-color proxima_semibold`}
                        >
                          {item.current_status.status == "Hold : Ticket Pending"
                            ? "Booking Holded"
                            : item.current_status.status}
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>

                <div className="airlines--stops--fares">
                  <div className="airbookings-content-wrapper">
                    {item.Data.map((itemm, id) => {
                      return (
                        <div className="airlines-data-userdb">
                          <div className="airline--info">
                            <AirlineLogos
                              length={itemm.AirlineLogos.length}
                              logos={itemm.AirlineLogos}
                            />

                            <div className="airline--info--data">
                              <span className="airline--name">
                                {itemm.AirlineNames?.map(
                                  (item, id) =>
                                    `${item}${id !== itemm.AirlineNames?.length - 1
                                      ? ", "
                                      : ""
                                    }`
                                )}
                              </span>
                              <span className="airline--code">
                                {itemm.AirlineNoAndOperatingCarrier?.map(
                                  (item, id) =>
                                    `${item}${id !==
                                      itemm.AirlineNoAndOperatingCarrier
                                        .length -
                                      1
                                      ? ", "
                                      : ""
                                    }`
                                )}
                              </span>
                            </div>
                          </div>
                          <div className="route--timings">
                            <div className="from--route--timings">
                              <div className="top-from--route--timing">
                                <div className="route--timing proxima_semibold">
                                  {itemm.originTime}{" "}
                                  <span className="proxima_semibold">
                                    {itemm.originDate}
                                  </span>
                                </div>
                                <div className="route--from proxima_semibold">
                                  {itemm.originInfo}
                                </div>
                              </div>
                            </div>
                            <div className="from-to--via--info">
                              <div className="route--timing--stops">
                                <div className="route--timing-top">
                                  <img src={images["timings-ico.svg"]} alt="" />
                                  {itemm.journeyTime}
                                </div>
                                <div className="route--timing-bottom">
                                  {itemm.stops}
                                </div>
                              </div>
                            </div>
                            <div className="to--route--timings">
                              <div className="top-to--route--timing">
                                <div className="route--timing proxima_semibold">
                                  {itemm.DesignationTime}{" "}
                                  <span className="proxima_semibold">
                                    {itemm.DesignationDate}
                                  </span>
                                </div>
                                <div className="route--from proxima_semibold">
                                  {itemm.DesignationInfo}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                  <div className="airline--booking--fare">
                    <div className="airline--booking--internal--fare">
                      <div className="top--airline--fare proxima_bold">
                        <img src={images["rupee-mybooking.svg"]} alt="" />{" "}
                        {formatPriceWithCommas(item.price)}
                      </div>
                      <span>Travellers: {item.travellers}</span>
                    </div>

                    {item.current_status.status == "Hold : Ticket Pending" ||
                      item.current_status.status == "Hold Expired" ? (
                      <div
                        className="airline--booking--internal--view"
                        onClick={() => proceedHoldBooking()}
                      >
                        <a>Pay Now</a>
                      </div>
                    ) : item.current_status.status == "Failed" ? (
                      <div
                        className="airline--booking--internal--view"
                        onClick={() =>
                          proceedFailedBooking(item.url, item.booking_id)
                        }
                      >
                        <a>Proceed</a>
                      </div>
                    ) : (
                      item.current_status.status != "Ticket Pending" && (
                        <div
                          className="airline--booking--internal--view"
                          onClick={() =>
                            navigate(
                              `/user/myflightbookings/${item.booking_id}`
                            )
                          }
                        >
                          <a>View</a>
                        </div>
                      )
                    )}
                  </div>
                </div>
                {item.documents.length > 0 && (
                  <div className="mybookings--cta--list">
                    <ul className="mybookings--cta--list--internal">
                      {item.documents.map((document, id) => {
                        return (
                          <li
                            className={document.classname}
                            key={id}
                            onClick={() => {
                              console.log(
                                "document isndie her eis : ",
                                document.Data
                              );

                              if (document.action == "download") {
                                downloadTicket(document.Data.data);
                              } else if (document.action == "print") {
                                let DataToSend = item.documents.filter(
                                  (item) => item.name == "Download E-Ticket"
                                )[0].Data.data;
                                printTicket(DataToSend);
                              } else if (document.action == "email") {
                                let DataToSend = item.documents.filter(
                                  (item) => item.name == "Download E-Ticket"
                                )[0].Data.data;
                                openTheEmailTicket(DataToSend);

                                // openpopup // open the popup and sned email
                              } else if (
                                document.action == "popup" &&
                                document.name == "Invoice"
                              ) {
                                openTheInvoice(document.Data);
                                // openpopup // open the popup and sned email
                              } else if (document.action == "redirect") {
                                let DataToSend = item.documents.filter(
                                  (item) => item.name == "Download E-Ticket"
                                )[0].Data.data;

                                openTheWebCheckin(document.links, DataToSend);

                                // openpopup // open the popup and sned email
                              }
                            }}
                          >
                            {document.name}
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                )}

                {item.hold_end_time && (
                  <div className="hold-separator">
                    <div className="proxima_semibold font18">
                      Hold Price : {/* {formatPriceWithCommas("5000")} */}
                      {formatPriceWithCommas(item.hold_price)}
                    </div>
                    <Timer time={item.hold_end_time} />
                  </div>
                )}
                {/* // todo form here  */}

                {item?.CancellationStatus && (
                  <div className="action-bottom-bar">
                    <ul className="action-process-list">
                      <li>
                        <img
                          src={
                            images[
                            item.CancellationStatus[0].isCompleted
                              ? "confirmed-cancel-icon.svg"
                              : "cancel-number-1-confirmed-icon.svg"
                            ]
                          }
                          alt=""
                        />
                        <div className="current-action-text">
                          <div className="process--title proxima_semibold">
                            {item.CancellationStatus[0].val}
                          </div>
                          <p className="proxima_semibold">
                            <span className="proxima_semibold">Status:</span>
                            {item.CancellationStatus[0].status}
                          </p>
                        </div>
                      </li>
                      <li
                        className={
                          item.CancellationStatus[1].isCompleted
                            ? ""
                            : "non-active-process"
                        }
                      >
                        <img
                          src={
                            images[
                            item.CancellationStatus[1].isCompleted
                              ? "cancel-number-2-confirmed-icon.svg"
                              : "cancel-number-2-non-confirmed-icon.svg"
                            ]
                          }
                          alt=""
                        />
                        <div className="current-action-text">
                          <div className="process--title proxima_semibold">
                            {item.CancellationStatus[0].val}
                          </div>
                          <p className="proxima_semibold">
                            <span className="proxima_semibold">Status:</span>
                            {item.CancellationStatus[0].status}
                          </p>
                        </div>
                      </li>
                    </ul>
                  </div>
                )}
              </li>
            );
          })}
        </ul>

        <Popup
          Open={openEmailTicketPopup}
          onClose={closeTheEmailTicketPopup}
          component={
            <EmailTicket Data={emailData} onClose={closeTheEmailTicketPopup} />
          }
        />

        <Popup
          Open={openCheckinPopup}
          onClose={closeTheCheckinPopup}
          component={
            <WebCheckin
              Data={CheckinData}
              links={CheckinLinks}
              onClose={closeTheCheckinPopup}
            />
          }
        />

        <Popup
          Open={OpenFailedBookingPopup}
          onClose={null}
          component={
            <FailedBookingPopup
              Data={FailedBookingPopupData}
              onClose={closeTheFailedBookingPopup}
            />
          }
        />

        <Popup
          Open={openInvoicePopup}
          onClose={closeTheInvoicePopup}
          component={
            <Invoice Data={invoiceData} onClose={closeTheInvoicePopup} />
          }
        />
      </div>
    </>
  );
}

export default MyFlightBookings;
